<script setup lang="ts">
    const handleClick = () => {
        // Remove cookie to disable draft mode
        useCookie(COOKIE_NAME_DRAFT_MODE, {
            secure: true,
            sameSite: 'none',
            path: '/',
            partitioned: true
        }).value = null;

        // Reload current page to load published content
        window.location.reload();
    };
</script>

<template>
    <button @click="handleClick">Leave Draft Mode</button>
</template>

<style lang="scss" scoped>
    button {
        position: fixed;
        top: 1rem;
        left: 50%;
        z-index: 50;
        transform: translateX(-50%);
        border: none;
        outline: none;
        background-color: hsl(0, 100%, 90%);
        color: black;
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
        font-size: small;

        &:hover,
        &:focus-visible {
            background-color: hsl(0, 100%, 80%);
        }

        &:active {
            background-color: hsl(0, 100%, 70%);
        }
    }
</style>
